import { Col, P, Row } from '@workramp/ui';
import styled from 'styled-components';

export const MediaObjectRow = styled(Row)`
  flex-wrap: nowrap;
`;

export const ContentCol = styled(Col)`
  min-width: 0;
`;

export const Description = styled(P)`
  color: ${({ theme }) => theme.colors.on[600]};
`;
